<template>
  <div class="banner" :style="backgroundImage" id="banner"></div>
</template>

<script setup lang="ts">
  interface ImageSource {
    imageName?: string;
    url: string;
    imageSize: string;
  }

  interface Props {
    imageSrc: ImageSource | null;
  }

  const props = withDefaults(defineProps<Props>(), {
    imageSrc: null
  });

  const nuxtApp = useNuxtApp();
  const eventBus = nuxtApp.$eventBus as any;

  const imageName = computed(() => {
    if (props.imageSrc && props.imageSrc.imageName) {
      return encodeURIComponent(props.imageSrc.imageName.trim());
    } else {
      return '';
    }
  });

  const backgroundImage = computed(() => {
    if (!props.imageSrc) return '';
    return "background-image: url('" + props.imageSrc.url + imageName.value + props.imageSrc.imageSize + "')";
  });

  onMounted(() => {
    eventBus?.emit('banner-mounted');
  });

  onUnmounted(() => {
    eventBus?.emit('banner-destroyed');
  });
</script>
